import { jsx as _jsx } from "react/jsx-runtime";
import { createApiClient } from "./api";
export { getCurrentBrowserUrl, isUnauthorizedError, isAuthEndpointUrl, createUnauthorizedLatch, isPublicRoute, isPublicRoutePath, PUBLIC_ROUTE_PATHS, } from "./api";
import { createQueryFactory } from "./queries";
import { createRequests } from "./requests";
import { createContext, useContext, useMemo } from "react";
export const createBrewardApiClient = (queryClient, clientConfig) => {
    const client = createApiClient(clientConfig);
    const requests = createRequests(client);
    const queries = createQueryFactory(requests, queryClient);
    return queries;
};
export const ApiClientContext = createContext(undefined);
export const ApiClientProvider = ({ children, queryClient, clientConfig }) => {
    // Built synchronously on purpose. Creating it in an effect left one commit in
    // which children already saw the new auth state while the context still held
    // the previous client - requests fired in that window went out without the
    // freshly issued token and came back 401, logging the user straight out again.
    const apiClient = useMemo(() => createBrewardApiClient(queryClient, clientConfig), [clientConfig, queryClient]);
    return (_jsx(ApiClientContext.Provider, { value: apiClient, children: children }));
};
export const useApiClient = () => {
    const apiClient = useContext(ApiClientContext);
    if (!apiClient) {
        throw new Error("useApiClient must be used within ApiClientProvider");
    }
    return apiClient;
};
export default createBrewardApiClient;
//# sourceMappingURL=index.js.map